import './DrawerChip.css';

interface Props {
  label: string;
  active?: boolean;
  count?: number;
  onClick?: () => void;
  as?: 'button' | 'span';
}

export function DrawerChip({ label, active, count, onClick, as = 'button' }: Props) {
  const Tag = as as any;
  return (
    <Tag
      className={`chip ${active ? 'chip--active' : ''}`}
      onClick={onClick}
      aria-pressed={as === 'button' ? String(Boolean(active)) : undefined}
      type={as === 'button' ? 'button' : undefined}
    >
      <span>{label}</span>
      {typeof count === 'number' && <span className="chip__count">{count}</span>}
    </Tag>
  );
}
